import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'

const LoanPropertyMultiUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick, onAddClick, onRemoveClick, onChange,
  // form fields
  propertyGroup, rowList
}) =>
  <ModalFormUI
    context={context}
    titleLabel={propertyGroup ? propertyGroup.titleLabel : 'Update property'}
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    {
      propertyGroup && rowList.map((row, index) =>
        <div key={index} className='g_m_bottom_100'>
          <div className='g_flex_h g_flex_right g_m_bottom_50'>
            <span className='g_muted g_small g_m_right_50'>
              {propertyGroup.rowLabel + ' ' + (index + 1)}
            </span>
            {
              rowList.length > 1 &&
              <span className='icon icon-trash-o g_link_2' title='Remove'
                data-index={index} onClick={onRemoveClick} />
            }
          </div>
          {
            propertyGroup.fieldList.map((field, fieldIndex) =>
              <InputTextSF key={field.key} type='text'
                name={field.key + '_' + index}
                label={field.label}
                maxLength={field.maxLength || 500}
                autoFocus={index === 0 && fieldIndex === 0}
                value={row[field.key] || ''}
                onChange={(event) => onChange(index, field.key, event)}
              />
            )
          }
        </div>
      )
    }
    {
      propertyGroup &&
      <div className='g_m_top_50'>
        <span className='g_link_2' onClick={onAddClick}>{propertyGroup.addLabel}</span>
      </div>
    }
  </ModalFormUI>

export default LoanPropertyMultiUpdateModalUI
